// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"5b413b4c","427":"8cab5ab9","802":"f918eaf9"}[chunkId] + ".chunk.js";
};